export const GET_PAGE_BY_ID = "GET_PAGE_BY_ID"
export const GET_PAGE_BY_ID_SUCCESS = "GET_PAGE_BY_ID_SUCCESS"
export const GET_WIDGETS = "GET_WIDGETS"
export const GET_WIDGETS_SUCCESS = "GET_WIDGETS_SUCCESS"
export const GET_PAGE_AND_WIDGETS_BY_PAGE_ID = "GET_PAGE_AND_WIDGETS_BY_PAGE_ID"
export const UPDATE_PAGE = "UPDATE_PAGE"
export const UPDATE_PAGE_SUCCESS = "UPDATE_PAGE_SUCCESS"
export const CREATE_WIDGETS_AND_UPDATE_PAGE = "CREATE_WIDGETS_AND_UPDATE_PAGE"

export const UPDATE_WIDGETS = "UPDATE_WIDGETS"
export const UPDATE_ONE_WIDGET = "UPDATE_ONE_WIDGET"
export const UPDATE_ONE_WIDGET_SUCCESS = "UPDATE_ONE_WIDGET_SUCCESS"

export const DELETE_WIDGETS = "DELETE_WIDGETS"

export const RESET_PAGE_PROPS = "RESET_PAGE_PROPS"
//DICTIONARY
export const SET_DICTIONARY_WIDGET_TEMP_NEW_ID = "SET_DICTIONARY_WIDGET_TEMP_NEW_ID"
export const CLEAR_DICTIONARY = "CLEAR_DICTIONARY"

// DEPRECATED: Filter state moved to FilterStore (CustomEvents). See app/grc/shared/stores/filterStore.ts
export const SET_FILTER_VALUE = "SET_FILTER_VALUE"
export const CLEAR_VALUE_FILTER_SELECTED = "CLEAR_VALUE_FILTER_SELECTED"
export const REMOVE_SELECTED_VALUE = "REMOVE_SELECTED_VALUE"

//COMPARISON VALUE SELECTION
export const SELECT_COMPARISON_VALUE = "SELECT_COMPARISON_VALUE"
export const REMOVE_COMPARISON_VALUE = "REMOVE_COMPARISON_VALUE"
export const CLEAR_COMPARISON_VALUES = "CLEAR_COMPARISON_VALUES"

//PAGE THUMBNAIL
export const SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL = "SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL"

//WIDGET DATA
export const GET_WIDGET_DATA = "GET_WIDGET_DATA"
export const GET_WIDGET_DATA_SUCCESS = "GET_WIDGET_DATA_SUCCESS"
export const GET_FIELD_INFOS = "GET_FIELD_INFOS"
export const GET_FIELD_INFOS_SUCCESS = "GET_FIELD_INFOS_SUCCESS"
export const CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT =
  "CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT"
export const CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED =
  "CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED"
export const CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT =
  "CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT"
export const CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED =
  "CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED"

//PERMISSION
export const GET_PAGE_PERMISSION = "GET_PAGE_PERMISSION"
export const GET_PAGE_PERMISSION_SUCCESS = "GET_PAGE_PERMISSION_SUCCESS"
export const CREATE_NEW_PAGE_PERMISSION = "CREATE_NEW_PAGE_PERMISSION"
export const CREATE_NEW_PAGE_PERMISSION_SUCCESS = "CREATE_NEW_PAGE_PERMISSION_SUCCESS"
export const UPDATE_PAGE_PERMISSION = "UPDATE_PAGE_PERMISSION"
export const UPDATE_PAGE_PERMISSION_SUCCESS = "UPDATE_PAGE_PERMISSION_SUCCESS"
export const DELETE_PAGE_PERMISSION = "DELETE_PAGE_PERMISSION"
export const DELETE_PAGE_PERMISSION_SUCCESS = "DELETE_PAGE_PERMISSION_SUCCESS"
export const UPDATE_PAGE_IS_PUBLIC = "UPDATE_PAGE_IS_PUBLIC"
export const UPDATE_PAGE_IS_PUBLIC_SUCCESS = "UPDATE_PAGE_IS_PUBLIC_SUCCESS"

//DUPLICATE, DELETE
export const DELETE_FULL_PAGE = "DELETE_FULL_PAGE"
export const DUPLICATE_PAGE = "DUPLICATE_PAGE"
export const DUPLICATE_CUBE_PAGE = "DUPLICATE_CUBE_PAGE"
export const DELETE_CUBE_PAGE = "DELETE_CUBE_PAGE"

// UPLOADS
export const UPLOAD_BACKGROUND_PAGE = "UPLOAD_BACKGROUND_PAGE"
export const UPLOAD_THUMBNAIL_PAGE = "UPLOAD_THUMBNAIL_PAGE"
export const UPLOAD_WIDGET_IMAGE_PAGE = "UPLOAD_WIDGET_IMAGE_PAGE"
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET"
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING"
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS"

// REQUEST STATUS
export const SET_WIDGET_REQUEST_STATUS = "SET_WIDGET_REQUEST_STATUS"

export const SET_LAST_WIDGET_SAVED = "SET_LAST_WIDGET_SAVED"

export const CHANGE_SAVING_PAGE_STATUS = "CHANGE_SAVING_PAGE_STATUS"

// DRILL DOWN
export const SET_DRILLDOWN_ENABLED = "SET_DRILLDOWN_ENABLED"
